import {SeasonModel} from "../../features/season/seasonTypes";

import React from "react";
import SeasonTitle from "../Title/Static/SeasonTitle/SeasonTitle";

type Props = {
    season: SeasonModel;
};

const SeasonItem = ({season}: Props) => {
    return (
        <><SeasonTitle/>
        <div className="col-md-6 px-2 pop-in">
            <div className="card bg-secondary card-event mb-3 hover-zoom ">
                <div className="position-relative o-hidden">
                    <a href={`/event/${season.slug}`}
                       className="position-absolute w-100 h-100 z-1"></a>
                    <img className="w-100"
                         src={season.image} alt={season.name}/>
                </div>
            </div>
        </div>
        </>
    )
}

export default SeasonItem;
